function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperTowels(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 850 850",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M588.05,145.13c-40.02,0-75.92-25.68-163.05-25.68s-119.23,25.68-163.05,25.68h-.48v582.9h.33c3.46,29.09,75.09,33.71,163.19,33.71s159.74-4.62,163.2-33.71h.33V145.13h-.48Z",
    style: {
      fill: "none",
      strokeWidth: 0
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -17.26,
    y: -20,
    width: 890,
    height: 890,
    style: {
      fill: "#003e6b",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "paper_towel",
    "data-name": "paper towel"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M588.05,145.13c-40.02,0-75.92-25.68-163.05-25.68s-119.23,25.68-163.05,25.68h-.48v582.9h.33c3.46,29.09,75.09,33.71,163.19,33.71s159.74-4.62,163.2-33.71h.33V145.13h-.48Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "434 173.95 416 190.28 434 206.6 416 222.92 434 239.25 416 255.57 434 271.9 416 288.22 434 304.55 416 320.88 434 337.2 416 353.53 434 369.85 416 386.18 434 402.5 416 418.83 434 435.16 416 451.48 434 467.81 416 484.14 434 500.46 416 516.79 434 533.12 416 549.45 434 565.77 416 582.1 434 598.43 416 614.76 434 631.08 416 647.41 434 663.74 416 680.07 434 696.4 416 712.73 434 729.06 416 745.4 434 761.73",
    style: {
      fill: "none",
      stroke: "#999",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, /*#__PURE__*/React.createElement("line", {
    x1: -141.26,
    y1: 456.22,
    x2: 552.99,
    y2: -35.63,
    style: {
      fill: "none",
      stroke: "#d9d9d9",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -114.4,
    y1: 481.6,
    x2: 579.85,
    y2: -10.26,
    style: {
      fill: "none",
      stroke: "#d9d9d9",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -88.69,
    y1: 506.97,
    x2: 605.56,
    y2: 15.12,
    style: {
      fill: "none",
      stroke: "#d9d9d9",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -63.22,
    y1: 532.35,
    x2: 631.03,
    y2: 40.49,
    style: {
      fill: "none",
      stroke: "#d9d9d9",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -33.91,
    y1: 557.72,
    x2: 660.34,
    y2: 65.87,
    style: {
      fill: "none",
      stroke: "#d9d9d9",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: -7.99,
    y1: 583.1,
    x2: 686.26,
    y2: 91.24,
    style: {
      fill: "none",
      stroke: "#d9d9d9",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.78,
    y1: 608.47,
    x2: 714.03,
    y2: 116.62,
    style: {
      fill: "none",
      stroke: "#d9d9d9",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.71,
    y1: 633.85,
    x2: 737.97,
    y2: 141.99,
    style: {
      fill: "none",
      stroke: "#d9d9d9",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 69.07,
    y1: 659.22,
    x2: 763.32,
    y2: 167.37,
    style: {
      fill: "none",
      stroke: "#d9d9d9",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.07,
    y1: 684.6,
    x2: 797.32,
    y2: 192.74,
    style: {
      fill: "none",
      stroke: "#d9d9d9",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 131.94,
    y1: 709.97,
    x2: 826.2,
    y2: 218.12,
    style: {
      fill: "none",
      stroke: "#d9d9d9",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 162.44,
    y1: 735.35,
    x2: 856.7,
    y2: 243.49,
    style: {
      fill: "none",
      stroke: "#d9d9d9",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 187.79,
    y1: 760.72,
    x2: 882.04,
    y2: 268.87,
    style: {
      fill: "none",
      stroke: "#d9d9d9",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.31,
    y1: 786.1,
    x2: 925.57,
    y2: 294.24,
    style: {
      fill: "none",
      stroke: "#d9d9d9",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.7,
    y1: 811.47,
    x2: 960.95,
    y2: 319.62,
    style: {
      fill: "none",
      stroke: "#d9d9d9",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300.74,
    y1: 836.85,
    x2: 994.99,
    y2: 344.99,
    style: {
      fill: "none",
      stroke: "#d9d9d9",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333.71,
    y1: 862.22,
    x2: 1027.97,
    y2: 370.37,
    style: {
      fill: "none",
      stroke: "#d9d9d9",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 361.4,
    y1: 887.6,
    x2: 1055.65,
    y2: 395.74,
    style: {
      fill: "none",
      stroke: "#d9d9d9",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 425,
    cy: 146.7,
    rx: 163.52,
    ry: 27.25,
    style: {
      fill: "#e6e6e6",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.89,146.7c0,5.79-28.16,10.48-62.89,10.48s-62.89-4.69-62.89-10.48,28.16-10.48,62.89-10.48,62.89,4.69,62.89,10.48Z",
    style: {
      fill: "#999",
      opacity: 0.5,
      strokeWidth: 0
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperTowels);
export default __webpack_public_path__ + "static/media/paper_towels.0cf907eb39fcc37a897d3281cbf9c643.svg";
export { ForwardRef as ReactComponent };